import { DynamicLayout, formBuilderConstants } from '../../formbuilder';
import { newStepValue } from '../../../../services/flowBuilder/utils/constants';

const redis0 = {
  json: {
    action: {
      name: '',
      description: '',
      actionType: 'redis',
      actionParams: {
        redisAction: '',
      },
      result: {
        yes: newStepValue,
        no: newStepValue,
      },
    },
    type: 'action',
  },
  paths: [
    'action.name',
    'action.description',
    'action.actionParams.redisAction',
    'action.result.#',
  ],
  groups: [
    {
      Parameters: ['action.name', 'action.description', 'action.actionParams.redisAction'],
    },
    {
      Logic: ['action.result.#'],
    },
  ],
};

const redis1 = {
  json: {
    action: {
      name: '',
      description: '',
      actionType: 'redis',
      actionParams: {
        redisAction: '',
        key: '',
      },
      result: {
        yes: newStepValue,
        no: newStepValue,
      },
    },
    type: 'action',
  },
  paths: [
    'action.name',
    'action.description',
    'action.actionParams.redisAction',
    'action.actionParams.key',
    'action.result.#',
  ],
  groups: [
    {
      Parameters: [
        'action.name',
        'action.description',
        'action.actionParams.redisAction',
        'action.actionParams.key',
      ],
    },
    {
      Logic: ['action.result.#'],
    },
  ],
};

const redis2 = {
  json: {
    action: {
      name: '',
      description: '',
      actionType: 'redis',
      actionParams: {
        redisAction: '',
        key: '',
        expire: '',
      },
      result: {
        yes: newStepValue,
        no: newStepValue,
      },
    },
    type: 'action',
  },
  paths: [
    'action.name',
    'action.description',
    'action.actionParams.redisAction',
    'action.actionParams.key',
    'action.actionParams.expire',
    'action.result.#',
  ],
  groups: [
    {
      Parameters: [
        'action.name',
        'action.description',
        'action.actionParams.redisAction',
        'action.actionParams.key',
        'action.actionParams.expire',
      ],
    },
    {
      Logic: ['action.result.#'],
    },
  ],
};

const redis3 = {
  json: {
    action: {
      name: '',
      description: '',
      actionType: 'redis',
      actionParams: {
        redisAction: '',
        key: '',
        expire: '',
        value: '',
      },
      result: {
        yes: newStepValue,
        no: newStepValue,
      },
    },
    type: 'action',
  },
  paths: [
    'action.name',
    'action.description',
    'action.actionParams.redisAction',
    'action.actionParams.key',
    'action.actionParams.expire',
    'action.actionParams.value',
    'action.result.#',
  ],
  groups: [
    {
      Parameters: [
        'action.name',
        'action.description',
        'action.actionParams.redisAction',
        'action.actionParams.key',
        'action.actionParams.expire',
        'action.actionParams.value',
      ],
    },
    {
      Logic: ['action.result.#'],
    },
  ],
};

export const redis: DynamicLayout = {
  json: {
    action: {
      name: '',
      description: '',
      actionType: 'redis',
      actionParams: {
        redisAction: '-',
      },
      result: {
        yes: newStepValue,
        no: newStepValue,
      },
    },
    type: 'action',
  },
  paths: [
    'action.name',
    'action.description',
    'action.actionParams.redisAction',
    'action.result.#',
  ],
  groups: [
    {
      Parameters: ['action.name', 'action.description', 'action.actionParams.redisAction'],
    },
    {
      Logic: ['action.result.#'],
    },
  ],
  layout: {
    name: {
      type: 'text',
      label: 'Name',
      validators: {
        required: true,
        spaceOnName: true,
      },
    },
    description: {
      type: 'text',
      label: 'Description',
      validators: {
        required: true,
      },
    },
    key: {
      type: 'text',
      label: 'Key',
      validators: {
        required: true,
      },
    },
    expire: {
      type: 'text',
      label: 'Expire',
      validators: {
        required: true,
      },
    },
    value: {
      type: 'text',
      label: 'Value',
      validators: {
        required: true,
      },
    },
    redisAction: {
      type: 'dropdown',
      label: 'Redis Action',
      attributes: {
        options: {
          [formBuilderConstants.DEFAULT_SELECT_OPTION_VALUE]:
            formBuilderConstants.DEFAULT_SELECT_OPTION_DESCRIPTION,
          decr: 'Decrement',
          decrBy: 'Decrement By',
          del: 'Delete',
          exist: 'Exist',
          get: 'Get',
          incr: 'Increment',
          incrBy: 'Increment By',
          set: 'Set',
        },
        data : true
      },
      validators: {
        required: true,
        optionSelected: true,
      },
    },
    result: {
      dataType: 'keyValue',
      key: {
        attributes: {
          readonly: true,
        },
        type: 'text',
        label: '#',
      },
      value: {
        attributes: {
          // readonly: false
        },
        type: 'next',
        label: 'Point to',
      },
    },
  },
  data: {
    dataPath: 'action.actionParams.redisAction',
    redisAction: {
      '-': redis0,
      decr: redis2,
      decrBy: redis3,
      del: redis1,
      exist: redis1,
      get: redis1,
      incr: redis2,
      incrBy: redis3,
      set: redis3,
    },
  },
};
